
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'store';
import { setCredentials, logout, hydrateAuth } from 'store/slices/auth';



export const useAuth = () => {
  const dispatch = useDispatch();

  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const setAuthCredentials = useCallback((token: string) => {
    dispatch(setCredentials(token));
  }, [dispatch]);

  const logoutUser = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  const hydrate = useCallback(() => {
    dispatch(hydrateAuth());
  }, [dispatch]);

  return {
    user,
    isAuthenticated,
    setAuthCredentials,
    logoutUser,
    hydrate,
  };
};

export const useUser = () => {
  return useSelector((state) => state.auth.user);
};

export const useIsAuthenticated = () => {
  return useSelector((state) => state.auth.isAuthenticated);
};